import { PriceListType } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type EvaluatedTierData = {
  tierId: string;
  minPrice: number | null;
  targetPrice: number | null;
  maxPrice: number | null;
};

export type EvaluatedPricesMap = Record<string, EvaluatedTierData>;

export const evaluateFormulasQueryAtom = createQueryAtomFactory(
  'brokerage.evaluateFormulas',
  (params: {
    priceListId: string;
    priceListType: PriceListType;
    asOf?: string;
  }) => ({
    evaluateFormulas: {
      __args: {
        priceListId: params.priceListId,
        priceListType: params.priceListType,
        ...(params.asOf ? { asOf: params.asOf } : {}),
      },
      itemPricing: {
        id: true,
      },
      evaluatedTiers: {
        tier: {
          id: true,
        },
        minPrice: true,
        targetPrice: true,
        maxPrice: true,
      },
    },
  }),
  {
    select: (data): EvaluatedPricesMap => {
      if (!data?.evaluateFormulas) return {};

      const map: EvaluatedPricesMap = {};
      for (const ep of data.evaluateFormulas) {
        for (const et of ep.evaluatedTiers) {
          map[et.tier.id] = {
            tierId: et.tier.id,
            minPrice: et.minPrice != null ? Number(et.minPrice) : null,
            targetPrice: et.targetPrice != null ? Number(et.targetPrice) : null,
            maxPrice: et.maxPrice != null ? Number(et.maxPrice) : null,
          };
        }
      }
      return map;
    },
  },
);
